import { SchedulerJobStatus } from './scheduler';
export var SqlRunnerFieldType;
(function (SqlRunnerFieldType) {
    SqlRunnerFieldType["TIME"] = "time";
    SqlRunnerFieldType["NUMBER"] = "number";
    SqlRunnerFieldType["STRING"] = "string";
    SqlRunnerFieldType["BOOLEAN"] = "boolean";
})(SqlRunnerFieldType || (SqlRunnerFieldType = {}));
var SqlRunnerTimeGranularity;
(function (SqlRunnerTimeGranularity) {
    SqlRunnerTimeGranularity["NANOSECOND"] = "NANOSECOND";
    SqlRunnerTimeGranularity["MICROSECOND"] = "MICROSECOND";
    SqlRunnerTimeGranularity["MILLISECOND"] = "MILLISECOND";
    SqlRunnerTimeGranularity["SECOND"] = "SECOND";
    SqlRunnerTimeGranularity["MINUTE"] = "MINUTE";
    SqlRunnerTimeGranularity["HOUR"] = "HOUR";
    SqlRunnerTimeGranularity["DAY"] = "DAY";
    SqlRunnerTimeGranularity["WEEK"] = "WEEK";
    SqlRunnerTimeGranularity["MONTH"] = "MONTH";
    SqlRunnerTimeGranularity["QUARTER"] = "QUARTER";
    SqlRunnerTimeGranularity["YEAR"] = "YEAR";
})(SqlRunnerTimeGranularity || (SqlRunnerTimeGranularity = {}));
export var SqlRunnerFilterBaseOperator;
(function (SqlRunnerFilterBaseOperator) {
    SqlRunnerFilterBaseOperator["IS"] = "IS";
    SqlRunnerFilterBaseOperator["IS_NOT"] = "IS_NOT";
})(SqlRunnerFilterBaseOperator || (SqlRunnerFilterBaseOperator = {}));
export var SqlRunnerFilterRelativeTimeValue;
(function (SqlRunnerFilterRelativeTimeValue) {
    SqlRunnerFilterRelativeTimeValue["TODAY"] = "TODAY";
    SqlRunnerFilterRelativeTimeValue["YESTERDAY"] = "YESTERDAY";
    SqlRunnerFilterRelativeTimeValue["LAST_7_DAYS"] = "LAST_7_DAYS";
    SqlRunnerFilterRelativeTimeValue["LAST_30_DAYS"] = "LAST_30_DAYS";
})(SqlRunnerFilterRelativeTimeValue || (SqlRunnerFilterRelativeTimeValue = {}));
export function isErrorDetails(results) {
    return results.error !== undefined;
}
export const isApiSqlRunnerJobSuccessResponse = (response) => response.status === SchedulerJobStatus.COMPLETED;
export const isApiSqlRunnerJobErrorResponse = (response) => response.status === SchedulerJobStatus.ERROR;
export const isApiSqlRunnerJobPivotQuerySuccessResponse = (response) => response.status === SchedulerJobStatus.COMPLETED;
//# sourceMappingURL=sqlRunner.js.map